import {
  Grid,
  Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import {
  CONST_SITE_LABEL,
  PLATFORM,
} from './common/Helper';
import './common/Styles.css'
import { useAuth } from '../state/AuthContext';
import { useScopedLocalStorage } from '../hooks/useScopedLocalStorage';
import { AWSOnboarding } from './AWSOnboarding';
import { AzureOnboarding } from './AzureOnboarding';

/**
 * Onboard Request Component
 * @returns 
 */
export const OnboardRequest = () => {
  const [username, setUsername] = useState('')

  const { selectedPlatform } = useAuth()
  const { setScopedItem, getScopedItem, removeScopedItem } = useScopedLocalStorage()

  const resetData = () => {
    if (getScopedItem('accountId')) {
      removeScopedItem('accountId')
    }

    if (getScopedItem('accountARN')) {
      removeScopedItem('accountARN')
    }
  }

  useEffect(() => {
    const userDetails = JSON.parse(getScopedItem('userDetails')) ?? ''
    let name = ''

    if (userDetails['firstname']) {
      name = userDetails['firstname']

      if (userDetails['lastname']) {
        name = `${userDetails['firstname']} ${userDetails['lastname']}`
      }

      setUsername(name)
    }
  })

  useEffect(() => {
    // resetData()

    return function cleanup() {
      // resetData()
    }
  }, [])

  return (
    <>
      <Grid container className='onboarding-page'>
        <Grid item xs={12} className='welcome-section'>
          <Typography variant='subtitle1' fontWeight={'bold'} color={'#012A4A'}>Hello {username},</Typography>
          <Typography variant='subtitle2' color={'#012A4A'}>Welcome to {CONST_SITE_LABEL}! Please complete your {selectedPlatform} onboarding according to the following instructions:</Typography>
        </Grid>
        <Grid item xs={12}>
          {selectedPlatform === PLATFORM.AZURE ? <AzureOnboarding /> : <AWSOnboarding /> }
        </Grid>
      </Grid>
    </>
  )
}